import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'


/**
 * @typedef {import('./js-doc').V2UpdateClientFactoringConfigRequest} V2UpdateClientFactoringConfigRequest
 * @typedef {import('./js-doc').V2ClientFactoringConfigResponse} V2ClientFactoringConfigResponse
 * @typedef {import('./js-doc').V2ReserveTotalResponse} V2ReserveTotalResponse
 * @typedef {import('./js-doc').V2ClientResponse} V2ClientResponse
 * @typedef {import('./js-doc').V2CreateClientBrokerProcessingNotesRequest} V2CreateClientBrokerProcessingNotesRequest
 * @typedef {import('./js-doc').V2UpdateClientBrokerProcessingNotesRequest} V2UpdateClientBrokerProcessingNotesRequest
 */

class Client {
  constructor () {
    this.baseURL = 'clients'
  }

  /**
   * @param {string} id  - client ID
   * @param {V2UpdateClientFactoringConfigRequest} payload - payload
   * @returns {Promise<V2ClientFactoringConfigResponse>}
   */
  async updateConfiguration (id, payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).patch(id, payload)
      return result?.data
    }
    catch (error) {
      CError('Could not update client config in V2 API', error)
      throw error
    }
  }

  /**
   * @param {string} id  - client ID
   * @returns {Promise<V2ClientResponse>}
   */
  async getOne (id) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).get(id)
      return result?.data
    }
    catch (error) {
      CError('Could not update client config in V2 API', error)
      throw error
    }
  }
}

export default Client
